'use strict';

import * as validationImport from './validation';
import * as numbersImport from './numbers';
import * as specImport from './spec';
import * as queryStringImport from './queryString';
import checkPermissionImport from './checkPermission';
import * as convertingImport from './converting';
import getHomePageImport from './getHomePage';


export const validation = validationImport;
export const numbers = numbersImport;
export const spec = specImport;
export const queryString = queryStringImport;
export const checkPermission = checkPermissionImport;
export const converting = convertingImport;
export const getHomePage = getHomePageImport;

export { default as translit } from './translit';
export { default as nounDeclension } from './nounDeclension';

export { default as Timer } from './timer';

export const uuid = () => {
  let dt = new Date().getTime();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt/16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
};

const withURLSearchParams = (query) => {
  const searchURL = new URLSearchParams(query);
  let params = {};
  for (let param of searchURL) {
    if ( !! param[1]) {
      let paramValue = param[1];
      if (/^\d{1,16}$/.test(paramValue)) {
        paramValue = Number(paramValue);
      } else if (/^\d+$/.test(paramValue)) {
        paramValue = String(paramValue);
      } else if (/^([0])+|([0]\w)+$/.test(paramValue)) {
        paramValue = String(paramValue);
      } else if (/^(true)$/.test(paramValue)) {
        paramValue = true;
      } else if (/^(false)$/.test(paramValue)) {
        paramValue = false;
      }
      params[param[0]] = paramValue;
    }
  }
  return params;
};

const withoutURLSearchParams = (query) => {
  // const search = query.substring(1);
  const search = new URLSearchParams(query);
  const objectResult = {};

  for (let [key, value] of search) {
    if (objectResult[key]) {
      if (objectResult[key] instanceof Array) {
        objectResult[key] = [...objectResult[key], value];
      }
      else {
        objectResult[key] = [objectResult[key], value];
      }
    }
    else {
      objectResult[key] = value;
    }
  }

  // return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}')

  return objectResult;
};

export const queryToObject = (query, options = { encoding: true }) => {
  if ( ! query) {
    return {};
  }
  if (options['encoding']) {
    return withURLSearchParams(query);
  }
  return withoutURLSearchParams(query);
};

export const objectToQuery = (object) => {
  let query = {};
  const searchURL = new URLSearchParams(query);

  for (let key in object) {
    if (object.hasOwnProperty(key)) {
      const value = object[key];
      if ( !! value) {
        if (value instanceof Array) {
          for (let index in value) {
            if (value.hasOwnProperty(index)) {
              const value2 = value[index];
              searchURL.append(key, value2);
            }
          }
        }
        else {
          searchURL.append(key, value);
        }
      }
    }
  }

  return '?' + decodeURI(searchURL.toString());
};


export const saveAs = (blob, fileName) => {
  if (navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = URL.createObjectURL(blob);
    const anchorElem = document.createElement('a');
    anchorElem.setAttribute('style', 'display: none;');
    anchorElem.setAttribute('href', url);
    anchorElem.setAttribute('download', fileName);

    document.body.appendChild(anchorElem);
    anchorElem.click();

    document.body.removeChild(anchorElem);

    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};

export const UUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,(c, r) => (
    ('x' === c)
      ? (Math.random() * 16 | 0)
      : ( r & 0x3 | 0x8)
    ).toString(16)
  );
};

export const sleep = async (seconds) => await new Promise((resolve) => setTimeout(resolve, seconds));

export const encodeHTML = (str) => {
  const buf = [];
  for (let i = str.length - 1; i >= 0; i --) {
    buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
  }
  return buf.join('');
};

export const decodeHTML = (str) => str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));

export { default as Events } from './Events';
